import React, { useContext } from "react";
import { Checkbox, FormControlLabel } from "@mui/material";
import { DiscoveryContext } from "../discovery-context";
import { useDashboardComponents } from "./useDashboardComponents";
import classes from "./SelectedComponent.module.css";

export default function DashboardCheckbox({ dashboardTab, dashboardName, category = null }) {
  const discoveryCtx = useContext(DiscoveryContext);
  const { componentKeys, allSelected, someSelected, componentCount } = useDashboardComponents(
    dashboardTab,
    category
  );
  if (componentCount === 0) return null;

  const handleToggle = () => {
    discoveryCtx.toggleDashboardSelection({componentKeys});
  };

  return (
    <div className={classes.dashboardCheckbox}>
      <FormControlLabel
        control={
          <Checkbox
            checked={allSelected}
            indeterminate={someSelected}
            onChange={handleToggle}
          />
        }
        label={`Select All ${dashboardName} (${componentCount} Combinations)`}
      />
    </div>
  );
}